import { Attr, IndexedMesh } from "./indexed-mesh";
import { IndexedMeshWriter } from "./indexed-mesh-writer";
import { disc, discIdx } from "./disc";


type DiscArrayAttrs = {
    normal: Attr,
    uv: Attr,
}

export class DiscArray extends IndexedMeshWriter<DiscArrayAttrs> {
    x: number;
    y: number;
    height: number;
    heights: number[];
    radius: number;
    n: number;

    /**
     * Matches the HoleArray mesh writer. These 
     */
    constructor(x: number, y: number, height: number, heights: number[],
                radius: number, n: number)
    {
        super();
        this.x = x;
        this.y = y;
        this.height = height;

        if(heights.length > 0) {
            // The upper and lower limits of holes that fall inside the array,
            // assuming our x coordinate is in the same global frame that the
            // heights are expressed in.
            const
                bottom = y + radius,
                top = y + height - radius,
                diameter = 2 * radius;
            let lastHeight = -Infinity;
            this.heights = heights.filter(h => {
                const distance = h - lastHeight;
                lastHeight = h;
                return h > bottom && h < top && distance >= diameter
            });
        }

        this.radius = radius;
        this.n = Math.max(3, n);
    }

    computeAttributeCounts(): IndexedMesh<DiscArrayAttrs> {
        const result = new IndexedMesh({
                normal: new Attr(3),
                uv: new Attr(2),
            }),
            m = this.heights.length,
            triangles = m*this.n,
            vertexes = m*(this.n + 1);

        result.index.count = triangles * 3;
        result.position.count = vertexes;
        result.attrs.normal.count = vertexes;
        result.attrs.uv.count = vertexes;

        return result;
    }

    computeMeshData(mesh: IndexedMesh<DiscArrayAttrs>): void {
        const
            triangles = this.n,
            vertexes = this.n + 1,
            idx = mesh.index.data,
            pos = mesh.position.data,
            norm = mesh.attrs.normal.data,
            uv = mesh.attrs.uv.data;
        let i = 0, p = 0, u = 0, v = 0;
        for(const h of this.heights) {
            disc(this.x, h, this.radius, this.n, pos, p, norm, uv, u);
            discIdx(v, this.n, idx, i);
            i += triangles * 3;
            p += vertexes * 3;
            u += vertexes * 2;
            v += vertexes;
        }
    }

}
